import { render, staticRenderFns } from "./MediaGroupArchiveMediaList.vue?vue&type=template&id=4ffa7c68&"
import script from "./MediaGroupArchiveMediaList.vue?vue&type=script&lang=js&"
export * from "./MediaGroupArchiveMediaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports